
const MODE="modern";                 /* "full" | "modern" */
/* ---------- palette (validated: see notes) ---------- */
const STRUCT = [
  ["identity",                  "Identity — ātman is brahman",                 "#2a78d6", false],
  ["emptiness",                 "Emptiness / non-position",                    "#eb6834", false],
  ["recognition",               "Primordial recognition",                      "#1baf7a", false],
  ["reflexive-luminosity",      "Reflexive luminosity",                        "#eda100", false],
  ["devotional-non-separation", "Devotional non-separation",                   "#e87ba4", false],
  ["process",                   "Process / non-differentiation",               "#008300", false],
  ["divine-unity",              "Divine unity & self-disclosure",              "#4a3aa7", false],
  ["apophatic-union",           "Apophatic union",                             "#e34948", false],
  ["relational-non-separation", "Relational non-separation",                   "#008300", true ],
  ["salvific-recognition",      "Salvific recognition (Gnostic)",              "#e34948", true ],
  ["modern-comparative",        "The modern comparative category",             "#8a7a63", false],
  ["contested",                 "Contested / resists the taxonomy",            "#6f6a62", false],
  ["not-applicable",            "Context, not a nondual claim",                "#a49c90", false]
];
const REGIONS = [
  ["vedic-north-india","Vedic & North India","#2a78d6",false],
  ["punjab","Punjab","#eb6834",false],
  ["south-india","South India","#1baf7a",false],
  ["gandhara","Gandhāra","#eda100",false],
  ["uddiyana-swat","Uḍḍiyāna / Swat","#eda100",true],
  ["kashmir","Kashmir","#e87ba4",false],
  ["tibet","Tibet","#4a3aa7",false],
  ["china","China","#008300",false],
  ["japan-korea-vietnam","Japan · Korea · Vietnam","#008300",true],
  ["persianate","Persianate world","#e34948",false],
  ["islamic-south-asia","Islamic South Asia","#e34948",true],
  ["mediterranean","Mediterranean","#4a3aa7",true],
  ["europe","Europe","#2a78d6",true],
  ["mesoamerica","Mesoamerica","#1baf7a",true],
  ["andes","Andes","#8a7a63",false],
  ["north-america-indigenous","North American Indigenous","#8a7a63",true],
  ["no-single-region","No single region — comparative & analytic","#6f6a62",false],
  ["global-transnational","Transnational (grouped)","#6f6a62",true]
];
const EVID = [["high","Securely dated","#54240e"],["medium","Reasonably dated","#87401f"],
              ["low","Weakly dated","#b06534"],["legendary","Legendary / traditional","#cf9057"]];
/* modern map: lanes are interpretive strands, not geography */
const STRANDS=[
 ["advaita-modern","Advaita & modern Vedānta"],
 ["sikh","Sikh · Udāsī · Nirmalā · Sant"],
 ["tibetan","Dzogchen · Mahāmudrā · Tibetan Buddhism"],
 ["zen","Chan · Zen · Sŏn · Thiền · Daoism"],
 ["saiva","Kashmir Śaiva & tantric traditions"],
 ["buddhist-other","Buddhist modernism & Insight"],
 ["sufi","Sufism & Islamic metaphysics"],
 ["christian","Christian, Neoplatonic & Jewish contemplative"],
 ["indigenous","Indigenous philosophies of the Americas"],
 ["science","Psychology, consciousness science & psychedelics"],
 ["scholarship","Historical-critical scholarship"],
 ["comparative","Comparative category-making & perennialism"],
 ["global","Global hybrid nonduality"]
];
const KINDS=[["person","Teacher / thinker","#2a78d6"],["institution","Institution","#eb6834"],
  ["text","Text / publication / translation","#1baf7a"],["movement","Movement / doctrine","#eda100"],
  ["school","School / lineage","#e87ba4"],["scholarship","Scholarship","#4a3aa7"],
  ["event","Event","#e34948"],["manuscript","Manuscript","#008300"]];
function strandOf(n){
  const d=n.domain||"", t=((n.tradition||"")+" "+(n.subtradition||"")+" "+n.label).toLowerCase();
  if(/udāsī|udasi|nirmal|sikh|gurbani|gurmat|sant |kabīr|kabir|ravidās|ravidas|namdev|dādū|radhasoami|singh sabha/.test(t)
     ||["udasi","nirmala","sikh-gurus","sant"].includes(d))return "sikh";
  if(/dzogchen|mahāmudrā|mahamudra|rnying|nyingma|kagyu|tibet|bön|bon |rimé|rime/.test(t)||d==="tibet")return "tibetan";
  if(/chan|zen|sŏn|seon|thiền|thien|daois|daoism|tiantai|huayan|kyoto school/.test(t)||d==="east-asia")return "zen";
  if(/śaiva|saiva|shaiva|trika|pratyabhijñā|kashmir|tantra|śākta|neotantra/.test(t)||d==="saiva")return "saiva";
  if(/sufi|ṣūfī|islam|ibn ʿarabī|ibn arabi|chisht|qādir|naqshband|traditionalis|perennialis.*schuon/.test(t)||d==="sufism")return "sufi";
  if(/christian|neoplaton|eckhart|contemplative prayer|centering prayer|orthodox|kabbal|jewish|monastic/.test(t)||d==="mediterranean")return "christian";
  if(/nahua|maya|andean|quechua|indigenous|nation|diné|navajo|lakota|anishinaabe|potawatomi|cree|cherokee/.test(t)||d==="indigenous")return "indigenous";
  if(/neuroscience|psycholog|psychedelic|cognitive|fmri|phenomenolog|mind and life|transpersonal|consciousness stud/.test(t))return "science";
  if(/advaita|vedānta|vedanta|ramana|nisargadatta|neo-advaita|satsang|direct path/.test(t))return "advaita-modern";
  if(/buddhis|vipassan|insight|theravād|theravada|mindfulness|madhyamaka|yogācāra/.test(t))return "buddhist-other";
  if(/scholarship|historiograph|philolog|orientalis|academic|studies/.test(t)||n.kind==="scholarship")return "scholarship";
  if(/perennial|comparative|mysticism|monism|category|world religions|theosoph/.test(t))return "comparative";
  return "global";
}

let LANE_ORDER = (MODE==="modern"?STRANDS:REGIONS).map(r=>r[0]);
let LANE_LABEL = Object.fromEntries((MODE==="modern"?STRANDS:REGIONS).map(r=>[r[0],r[1]]));
function setLanes(mode){
  const src = mode==="strand" ? STRANDS : REGIONS;
  LANE_ORDER = src.map(r=>r[0]);
  LANE_LABEL = Object.fromEntries(src.map(r=>[r[0],r[1]]));
}
const laneOf = n => (S.lanes==="strand")
  ? (n._strand||(n._strand=strandOf(n)))
  : ((S.transnat==="group" && n.transnat) ? "global-transnational" : (n.region2||n.region));
const CTYPE = {
  A:["Documented transmission","#2f6f3f","0"],
  B:["Strongly supported contact","#3a6ea8","0"],
  C:["Plausible contact","#8a7326","5 3"],
  D:["Philosophical parallel — no transmission demonstrated","#8a8072","2 4"],
  E:["Contested connection","#a63a3a","7 4"],
  F:["Traditional lineage claim","#7b4a9c","1 4"]
};
const CONF_ORDER=["high","medium","low","legendary"];
/* dark-mode steps: same hues re-stepped for the Akaal surface, validated as a set */
const DARK={"#2a78d6":"#3987e5","#eb6834":"#d95926","#1baf7a":"#199e70","#eda100":"#c98500",
 "#e87ba4":"#d55181","#008300":"#008300","#4a3aa7":"#9085e9","#e34948":"#e66767",
 "#8a7a63":"#b3a086","#6f6a62":"#9d968a","#a49c90":"#7f786d",
 "#54240e":"#e8b98d","#87401f":"#cf9057","#b06534":"#b06534","#cf9057":"#8f4522"};
const isDark=()=>document.documentElement.dataset.theme==="akaal";
function lum(hex){const m=hex.replace("#","");const f=i=>{const v=parseInt(m.substr(i,2),16)/255;
  return v<=.03928?v/12.92:Math.pow((v+.055)/1.055,2.4);};
  return .2126*f(0)+.7152*f(2)+.0722*f(4);}
const D=c=>isDark()?(DARK[c]||c):c;

/* ---------- state ---------- */
let DB=null, NODES=[], CONNS=[], BYID={}, OUT={}, INN={};
const S0={lanes:(MODE==="modern"?"strand":"geo"),transnat:"inline",searchMode:"matches",
         colorMode:"structure",axisMode:"linear",edgeMode:"sel",
         sel:null,q:"",scope:"core",view:"chart",nodeSet:null,
         t0:(MODE==="modern"?1900:-900),t1:2030};
const S={lanes:(MODE==="modern"?"strand":"geo"),transnat:"inline",searchMode:"matches",
        nodeSet:null,
        colorMode:"structure",axisMode:"linear",edgeMode:"sel",t0:(MODE==="modern"?1900:-900),t1:2030,
         sel:null,q:"",scope:"core",types:new Set("ABCDEF"),confs:new Set(CONF_ORDER),view:"chart"};

/* ---------- load ---------- */
function b64ToBytes(b64){const bin=atob(b64.trim());const u=new Uint8Array(bin.length);
  for(let i=0;i<bin.length;i++)u[i]=bin.charCodeAt(i);return u;}
async function boot(){
  const raw=(window.__ATLAS_PAYLOAD__||"");
  let text;
  try{
    const bytes=b64ToBytes(raw);
    const ds=new DecompressionStream("gzip");
    const stream=new Blob([bytes]).stream().pipeThrough(ds);
    text=await new Response(stream).text();
  }catch(e){
    document.getElementById("loading").innerHTML="This page needs a current browser to unpack its "+
      "database (it uses the standard DecompressionStream API). Please open it in an up-to-date "+
      "Chrome, Edge, Safari or Firefox.";
    return;
  }
  DB=JSON.parse(text);
  NODES=DB.nodes; CONNS=DB.connections;
  NODES.forEach(n=>{BYID[n.id]=n; n._s=(n.date_start??0); n._e=Math.max(n.date_end??n._s,n._s);
    n._hay=(n.label+" "+n.tradition+" "+(n.subtradition||"")+" "+(n.concepts||[]).join(" ")+" "+
            (n.nondual_types||[]).join(" ")).toLowerCase();});
  CONNS.forEach(c=>{(OUT[c.from]=OUT[c.from]||[]).push(c);(INN[c.to]=INN[c.to]||[]).push(c);});
  document.getElementById("loading").remove();
  ["minimap","hint","viz","axisBarWrap"].forEach(id=>document.getElementById(id).hidden=false);
  buildStats(); buildFilters(); buildLegend(); buildBiblio(); bindUI();
  if(MODE==="modern"){document.getElementById("regionBtn").textContent="Kind";
    document.querySelectorAll("[data-fullonly]").forEach(e=>e.remove());}
  computeEraScale(); syncControls(); render(); renderMinimap();
  if(PENDING_NODE){ const id=PENDING_NODE; PENDING_NODE=null;
    if(BYID[id]) showEvidence(id,null); }
  if(PENDING_SET){ const s2=PENDING_SET; PENDING_SET=null; showSet(s2[0],s2[1]); }
}

/* ---------- stats ---------- */
function buildStats(){
  const cites=NODES.reduce((a,n)=>a+(n.citations||[]).length,0)+
              CONNS.reduce((a,c)=>a+(c.citations||[]).length,0);
  const D=CONNS.filter(c=>c.type==="D").length, E=CONNS.filter(c=>c.type==="E").length,
        F=CONNS.filter(c=>c.type==="F").length, A=CONNS.filter(c=>c.type==="A").length;
  const rows=[[NODES.length,"Entries"],[CONNS.length,"Classified links"],[cites.toLocaleString(),"Citations"],
    [A,"Documented"],[E,"Contested"],[D,"Parallel only"],[F,"Traditional claims"],
    [LANE_ORDER.length,"Cultural lanes"]];
  document.getElementById("stats").innerHTML=rows.map(r=>
    `<div class="stat"><span class="n">${r[0]}</span><span class="l">${r[1]}</span></div>`).join("");
}

/* ---------- filters + legend ---------- */
function buildFilters(){
  document.getElementById("connFilters").innerHTML=Object.entries(CTYPE).map(([k,v])=>
    `<button class="pill" data-t="${k}" aria-pressed="true"><span class="sw" style="background:${v[1]}"></span>${k} · ${v[0].split("—")[0].trim()}</button>`).join("");
  document.getElementById("confFilters").innerHTML=EVID.map(e=>
    `<button class="pill" data-c="${e[0]}" aria-pressed="true"><span class="sw" style="background:${e[2]}"></span>${e[1]}</button>`).join("");
  document.getElementById("connFilters").onclick=e=>{const b=e.target.closest(".pill");if(!b)return;
    const on=b.getAttribute("aria-pressed")==="true";b.setAttribute("aria-pressed",!on);
    on?S.types.delete(b.dataset.t):S.types.add(b.dataset.t);render();};
  document.getElementById("confFilters").onclick=e=>{const b=e.target.closest(".pill");if(!b)return;
    const on=b.getAttribute("aria-pressed")==="true";b.setAttribute("aria-pressed",!on);
    on?S.confs.delete(b.dataset.c):S.confs.add(b.dataset.c);render();renderMinimap();};
}
function activeScale(){
  if(S.colorMode==="structure")return STRUCT;
  if(S.colorMode==="region")return MODE==="modern"?KINDS.map(k=>[k[0],k[1],k[2],false]):REGIONS;
  return EVID.map(e=>[e[0],e[1],e[2],false]);}
function buildLegend(){
  const sc=activeScale();
  document.getElementById("legendTitle").textContent =
    S.colorMode==="structure"?"Structure of non-separation":
    S.colorMode==="region"?(MODE==="modern"?"Kind of entry":"Cultural lane"):"Confidence of dating";
  document.getElementById("legend").innerHTML=sc.map(s=>
    `<span class="lit"><span class="sw" style="background:${D(s[2])}${s[3]?';background-image:repeating-linear-gradient(45deg,rgba(255,255,255,.75) 0 1.5px,transparent 1.5px 4px)':''}"></span>${s[1]}</span>`).join("");
  document.getElementById("legend2").innerHTML =
    `<span class="lit" style="color:var(--ink-m);font-size:10.5px;letter-spacing:.13em;text-transform:uppercase">Lines</span>`+
    Object.entries(CTYPE).map(([k,v])=>
      `<span class="lit"><span class="ln" style="border-top-color:${v[1]};border-top-style:${v[2]==="0"?"solid":"dashed"}"></span>${k}</span>`).join("")+
    `<span class="lit" style="margin-left:12px"><span class="sw" style="background:var(--ink-m);background-image:repeating-linear-gradient(45deg,rgba(255,255,255,.75) 0 1.5px,transparent 1.5px 4px)"></span>hatched = legendary or low-confidence dating</span>`;
}

/* ---------- colour ---------- */
function colorOf(n){
  if(S.colorMode==="evidence"){const e=EVID.find(x=>x[0]===n.date_confidence);return[D(e?e[2]:"#8a8072"),false];}
  if(S.colorMode==="region"){
    if(MODE==="modern"){const k=KINDS.find(x=>x[0]===n.kind);return[D(k?k[2]:"#8a8072"),false];}
    const r=REGIONS.find(x=>x[0]===laneOf(n));return r?[D(r[2]),r[3]]:[D("#8a8072"),false];}
  const t=(n.nondual_types||["contested"]).filter(t=>t!=="not-applicable" && t!=="contested");
  const key=(t[0]||(n.nondual_types||[])[0]||"contested");
  const s=STRUCT.find(x=>x[0]===key);return s?[D(s[2]),s[3]]:[D("#6f6a62"),false];
}
const uncertain=n=>n.date_confidence==="legendary"||n.date_confidence==="low";

/* ---------- scales ---------- */
const ERAS=MODE==="modern"?[[1898,1920],[1920,1945],[1945,1960],[1960,1975],[1975,1990],[1990,2000],[2000,2010],[2010,2018],[2018,2027]]
  :[[-1500,-800],[-800,-200],[-200,200],[200,500],[500,800],[800,1100],[1100,1400],
            [1400,1600],[1600,1800],[1800,1900],[1900,1945],[1945,1980],[1980,2000],[2000,2027]];
let eraCum=[];
function computeEraScale(){
  const w=ERAS.map(e=>{const c=NODES.filter(n=>n._s<e[1]&&n._e>=e[0]).length;return Math.max(0.4,Math.sqrt(c));});
  const tot=w.reduce((a,b)=>a+b,0);let acc=0;eraCum=ERAS.map((e,i)=>{const a=acc;acc+=w[i]/tot;return[e[0],e[1],a,acc];});
}
function toU(y){ // year -> unit 0..1 in axis space
  if(S.axisMode==="linear"){const lo=MODE==="modern"?1898:-1500;return (y-lo)/(2027-lo);}
  for(const [a,b,u0,u1] of eraCum){ if(y<a) return u0; if(y<=b) return u0+(u1-u0)*(y-a)/(b-a); }
  return 1;
}
function fromU(u){
  if(S.axisMode==="linear"){const lo=MODE==="modern"?1898:-1500;return lo+u*(2027-lo);}
  for(const [a,b,u0,u1] of eraCum){ if(u<=u1) return a+(b-a)*Math.max(0,(u-u0))/(u1-u0); }
  return 2027;
}
let X=y=>0, W=1200, PADL=250;
function makeX(w){ const u0=toU(S.t0),u1=toU(S.t1);
  X=y=>PADL+((toU(y)-u0)/(u1-u0))*(w-PADL-18); W=w; }
function invX(px){ const u0=toU(S.t0),u1=toU(S.t1);
  return fromU(u0+((px-PADL)/(W-PADL-18))*(u1-u0)); }

/* ---------- render ---------- */
const NS="http://www.w3.org/2000/svg";
const el=(t,a)=>{const e=document.createElementNS(NS,t);for(const k in a)e.setAttribute(k,a[k]);return e;};
function visible(n){
  if(S.nodeSet && !S.nodeSet.has(n.id))return false;
  if(!S.confs.has(n.date_confidence))return false;
  if(S.q && S.searchMode==="matches" && !n._hay.includes(S.q))return false;
  if(S.scope==="core" && (n.nondual_types||[]).length && (n.nondual_types||[]).every(t=>t==="not-applicable"))return false;
  if(n._e< S.t0 || n._s > S.t1)return false;
  return true;
}
function matchQ(n){return !S.q || n._hay.includes(S.q);}

function render(){
  const svg=document.getElementById("viz");
  const w=svg.clientWidth||svg.parentNode.clientWidth;
  makeX(w);
  while(svg.firstChild)svg.removeChild(svg.firstChild);
  const defs=el("defs");svg.appendChild(defs);
  const patterns=new Set();
  const NH=16,GAP=5,LANEPAD=13;
  let y=34, laneMeta=[];
  const gBg=el("g"),gAx=el("g"),gEdge=el("g"),gNode=el("g");
  const rows={}; // id -> {x,y,w}
  LANE_ORDER.forEach((lane,li)=>{
    const items=NODES.filter(n=>laneOf(n)===lane&&visible(n))
      .sort((a,b)=>a._s-b._s||a._e-b._e);
    const ends=[];
    const placed=items.map(n=>{
      let x0=Math.max(PADL,X(n._s)), x1=Math.max(Math.min(X(n._e),w-16),x0+7);
      let r=0;while(r<ends.length&&ends[r]>x0-3)r++;
      ends[r]=x1;return{n,x0,x1,r,next:Infinity};
    });
    const byRow={};placed.forEach(p=>{(byRow[p.r]=byRow[p.r]||[]).push(p);});
    Object.values(byRow).forEach(arr=>{arr.sort((a,b)=>a.x0-b.x0);
      for(let i=0;i<arr.length-1;i++)arr[i].next=arr[i+1].x0;});
    const nrows=Math.max(1,ends.length);
    const h=nrows*(NH+GAP)+LANEPAD*2;
    laneMeta.push({lane,y,h,n:items.length});
    gBg.appendChild(el("rect",{class:"lanebg"+(li%2?" alt":""),x:0,y:y,width:w,height:h}));
    gBg.appendChild(el("line",{class:"lanerule",x1:0,y1:y+h,x2:w,y2:y+h}));
    const lt=el("text",{class:"lanelabel",x:14,y:y+20});lt.textContent=LANE_LABEL[lane];gBg.appendChild(lt);
    const lc=el("text",{class:"lanelabel",x:14,y:y+39});
    lc.textContent=items.length+" entries · "+(S.lanes==="strand"?"interpretive strand":"geographic region");
    lc.setAttribute("fill","var(--ink-m)");lc.setAttribute("font-size","11");lc.setAttribute("font-weight","400");gBg.appendChild(lc);
    placed.forEach(p=>{
      const yy=y+LANEPAD+p.r*(NH+GAP);
      rows[p.n.id]={x:(p.x0+p.x1)/2,y:yy+NH/2,x0:p.x0,x1:p.x1};
      const [col,tex]=colorOf(p.n);
      const hatch=tex||uncertain(p.n);
      let fill=col;
      if(hatch){const pid="p"+col.slice(1)+(tex?"a":"b");
        if(!patterns.has(pid)){patterns.add(pid);
          const pat=el("pattern",{id:pid,width:5,height:5,patternTransform:"rotate(45)",patternUnits:"userSpaceOnUse"});
          pat.appendChild(el("rect",{width:5,height:5,fill:col}));
          pat.appendChild(el("rect",{width:2,height:5,fill:isDark()?"rgba(22,20,15,.62)":"rgba(255,255,255,.72)"}));
          defs.appendChild(pat);}
        fill="url(#"+pid+")";}
      const g=el("g",{class:"node"+(S.q&&S.searchMode==="dim"&&!matchQ(p.n)?" dim":"")
        +(S.sel===p.n.id?" sel":"")+((p.n.transnat&&S.lanes==="geo")?" tn":"")});
      g.dataset.id=p.n.id;
      g.setAttribute("tabindex","0");
      g.setAttribute("role","button");
      g.setAttribute("aria-label",p.n.label+" — "+p.n.date_display+". Open its evidence record.");
      g.appendChild(el("rect",{x:p.x0,y:yy,width:Math.max(6,p.x1-p.x0),height:NH,rx:2.5,
        fill:fill,stroke:col,"stroke-opacity":".55"}));
      const room=Math.min(p.next-p.x1-6, w-p.x1-24), span=p.x1-p.x0;
      const put=(txt,x,fill)=>{const t=el("text",{class:"nlabel",x:x,y:yy+NH-2.2});
        if(fill)t.setAttribute("fill",fill);t.textContent=txt;g.appendChild(t);};
      const cut=(px)=>{const c=Math.floor(px/6.6);
        return p.n.label.length>c?p.n.label.slice(0,Math.max(3,c-1)).trimEnd()+"…":p.n.label;};
      if(room>38){ put(cut(room),p.x1+7); }
      else if(span>170){ put(cut(span-14),p.x0+7, hatch?(isDark()?"#f2ece0":"#1d1a16"):(lum(col)>0.62?"#1d1a16":"#fff")); }
      gNode.appendChild(g);
    });
    y+=h;
  });
  const H=y+16;
  svg.setAttribute("height",H);svg.setAttribute("viewBox",`0 0 ${w} ${H}`);
  /* axis */
  const ticks=makeTicks();
  ticks.forEach(t=>{
    const px=X(t.y); if(px<PADL-2||px>w)return;
    const g=el("g",{class:"tick"+(t.major?" major":"")});
    g.appendChild(el("line",{x1:px,y1:30,x2:px,y2:H-6,"stroke-opacity":t.major?".85":".4"}));
    const tx=el("text",{x:px+4,y:22});tx.textContent=t.label;g.appendChild(tx);
    gAx.appendChild(g);
  });
  /* edges */
  if(S.edgeMode!=="none"){
    const list=S.edgeMode==="all"?CONNS:
      (S.sel?[...(OUT[S.sel]||[]),...(INN[S.sel]||[])]:[]);
    list.forEach(c=>{
      if(!S.types.has(c.type))return;
      const a=rows[c.from],b=rows[c.to];if(!a||!b)return;
      const st=CTYPE[c.type];
      const mx=(a.x+b.x)/2, my=(a.y+b.y)/2 - Math.min(140,Math.abs(b.y-a.y)*.32+Math.abs(b.x-a.x)*.09);
      const p=el("path",{class:"edge"+(S.edgeMode==="all"&&S.sel&&c.from!==S.sel&&c.to!==S.sel?" dim":""),
        d:`M${a.x},${a.y} Q${mx},${my} ${b.x},${b.y}`,stroke:st[1],
        "stroke-width":S.edgeMode==="all"?0.85:1.7,"stroke-opacity":S.edgeMode==="all"?.32:.85});
      if(st[2]!=="0")p.setAttribute("stroke-dasharray",st[2]);
      gEdge.appendChild(p);
    });
  }
  svg.append(gBg,gAx,gEdge,gNode);
  /* sticky axis bar */
  const ab=document.getElementById("axisBar");
  while(ab.firstChild)ab.removeChild(ab.firstChild);
  ab.setAttribute("viewBox",`0 0 ${w} 26`);
  ticks.forEach(t=>{const px=X(t.y);if(px<PADL-2||px>w-4)return;
    const g=el("g",{class:"tick"+(t.major?" major":"")});
    g.appendChild(el("line",{x1:px,y1:18,x2:px,y2:26,"stroke-opacity":t.major?".9":".45"}));
    const tx=el("text",{x:px+4,y:14});tx.textContent=t.label;g.appendChild(tx);ab.appendChild(g);});
  const lb=el("text",{x:14,y:16,class:"lanelabel"});
  lb.textContent=(S.t0<0?Math.abs(Math.round(S.t0))+" BCE":Math.round(S.t0)+" CE")+"  –  "+
                 (S.t1<0?Math.abs(Math.round(S.t1))+" BCE":Math.round(S.t1)+" CE");
  lb.setAttribute("font-weight","600");ab.appendChild(lb);
  attachNodeEvents(svg);
  if(S.view==="table")renderTable();
}
function makeTicks(){
  const span=S.t1-S.t0;
  const step=span>2200?500:span>1000?200:span>420?100:span>200?50:span>90?20:span>36?10:5;
  const out=[];
  let start=Math.ceil(S.t0/step)*step;
  for(let yv=start;yv<=S.t1;yv+=step){
    out.push({y:yv,major:yv%(step*5)===0||yv===0,
      label:yv<0?Math.abs(yv)+" BCE":(yv===0?"1 CE":yv+(yv<1000?" CE":""))});
  }
  return out;
}
function attachNodeEvents(svg){
  const tip=document.getElementById("tip");
  svg.addEventListener("mousemove",e=>{
    const g=e.target.closest(".node");
    if(!g){tip.style.display="none";return;}
    const n=BYID[g.dataset.id];
    tip.innerHTML=`<div class="t">${esc(n.label)}</div><div class="m">${esc(n.date_display)} · ${esc(LANE_LABEL[laneOf(n)]||laneOf(n))}</div>
      <div class="m" style="margin-top:4px">${esc(n.tradition)}</div>
      <div class="m" style="margin-top:5px;color:var(--rust)">${(n.nondual_types||[]).join(" · ")}</div>
      <div class="m" style="margin-top:5px">${esc(n.date_confidence)} confidence · ${esc(n.date_type)} · ${(n.citations||[]).length} sources</div>`;
    tip.style.display="block";
    const r=tip.getBoundingClientRect();
    tip.style.left=Math.min(e.clientX+16,innerWidth-r.width-12)+"px";
    tip.style.top=Math.min(e.clientY+16,innerHeight-r.height-12)+"px";
  });
  svg.addEventListener("mouseleave",()=>tip.style.display="none");
  svg.addEventListener("click",e=>{const g=e.target.closest(".node");
    if(g){ if(typeof showEvidence==="function") showEvidence(g.dataset.id,g);
           else openPanel(g.dataset.id); } });
  svg.addEventListener("keydown",e=>{
    if(e.key!=="Enter"&&e.key!==" ")return;
    const g=e.target.closest(".node"); if(!g)return;
    e.preventDefault();
    if(typeof showEvidence==="function") showEvidence(g.dataset.id,g);
    else openPanel(g.dataset.id); });
}
const esc=s=>String(s==null?"":s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));

/* ---------- minimap ---------- */
function renderMinimap(){
  const c=document.getElementById("minimap");
  const w=c.clientWidth,h=46;c.width=w*devicePixelRatio;c.height=h*devicePixelRatio;
  const x=c.getContext("2d");x.scale(devicePixelRatio,devicePixelRatio);
  x.clearRect(0,0,w,h);
  const bins=new Array(180).fill(0);
  NODES.forEach(n=>{if(!S.confs.has(n.date_confidence))return;
    const u=Math.max(0,Math.min(.999,toU(n._s)));bins[Math.floor(u*180)]++;});
  const mx=Math.max(...bins,1);
  bins.forEach((v,i)=>{const bh=Math.round((v/mx)*(h-8));
    x.fillStyle=getComputedStyle(document.body).getPropertyValue("--copper").trim()||"#b0703c";
    x.globalAlpha=.55;x.fillRect(i*(w/180),h-4-bh,Math.max(1,w/180-.6),bh);});
  x.globalAlpha=1;
  const a=toU(S.t0)*w,b=toU(S.t1)*w;
  x.fillStyle="rgba(143,69,34,.13)";x.fillRect(a,0,b-a,h);
  x.strokeStyle="#8f4522";x.lineWidth=1;x.strokeRect(a+.5,.5,Math.max(2,b-a-1),h-1);
}
function bindMinimap(){
  const c=document.getElementById("minimap");let drag=null;
  const yr=e=>{const r=c.getBoundingClientRect();return fromU(Math.max(0,Math.min(1,(e.clientX-r.left)/r.width)));};
  c.addEventListener("pointerdown",e=>{drag={a:yr(e)};c.setPointerCapture(e.pointerId);});
  c.addEventListener("pointermove",e=>{if(!drag)return;const b=yr(e);
    const LO=(MODE==="modern"?1895:-1520), HI=(MODE==="modern"?2032:2040), MIN=25;
    let a=Math.min(drag.a,b), z=Math.max(drag.a,b);
    if(z-a<MIN){
      /* grow into whichever side has room, so a drag at either end of the
         axis does not silently slide the whole interval */
      const need=MIN-(z-a), room_hi=HI-z, room_lo=a-LO;
      const up=Math.min(need,Math.max(0,room_hi));
      z+=up; a-=Math.min(need-up,Math.max(0,room_lo));
    }
    S.t0=Math.max(LO,a); S.t1=Math.min(HI,z);
    if(S.t1-S.t0<MIN){ S.t0=Math.max(LO,S.t1-MIN); }
    render();renderMinimap();syncControls();});
  c.addEventListener("pointerup",()=>drag=null);
}

/* ---------- panel ---------- */
function sourceTier(c){
  const u=(c.url||"").toLowerCase(), k=(c.kind||"").toLowerCase(), r=(c.ref||"").toLowerCase();
  if(/manuscript|primary|scripture|translation/.test(k) || /srigranth|banidb|archive\.org/.test(u)) return ["primary","primary / text"];
  if(/doi\.org|cambridge|oup|oxford|brill|springer|harvard|ucpress|sunypress|jstor|projectmuse|journal/.test(u+r) || /article|book|doi/.test(k)) return ["scholarly","scholarly"];
  if(/plato\.stanford|iep\.utm|encyclop/.test(u+r)) return ["reference","reference"];
  if(/earlytibet|ibnarabisociety|gurmatveechar|thesikhencyclopedia|advaita-vedanta/.test(u)) return ["tradition","specialist / tradition"];
  return ["","source"];
}
function citeList(cits){
  if(!cits||!cits.length)return `<li class="nolink">No source recorded.</li>`;
  return cits.map(c=>{
    const ref=esc(c.ref), tier=sourceTier(c);
    const badge=`<span class="source-tier ${tier[0]}">${tier[1]}</span>`;
    return `<li>${c.url?`<a href="${esc(c.url)}" target="_blank" rel="noopener">${ref}</a>`
      :`${ref} <span class="nolink">— no stable public URL; reference given in full</span>`}${badge}</li>`;
  }).join("");
}
function openPanel(id){
  const n=BYID[id];if(!n)return;
  S.sel=id;
  const edges=[...(OUT[id]||[]).map(c=>[c,"→",BYID[c.to]]),...(INN[id]||[]).map(c=>[c,"←",BYID[c.from]])];
  const body=document.getElementById("panelBody");
  body.innerHTML=`
   <h2>${esc(n.label)}</h2>
   <div class="m" style="font-family:var(--sans);font-size:14px;color:var(--ink-m)">${esc(n.date_display)}</div>
   <div class="evidence-summary">
     <div class="evidence-card"><span class="v">${esc(n.date_confidence)}</span><span class="k">date confidence</span></div>
     <div class="evidence-card"><span class="v">${(n.citations||[]).length}</span><span class="k">supporting sources</span></div>
     <div class="evidence-card"><span class="v">${edges.length}</span><span class="k">mapped connections</span></div>
   </div>
   <dl class="kv">
     <dt>Lane</dt><dd>${esc(LANE_LABEL[laneOf(n)]||laneOf(n))}</dd>
     <dt>Tradition</dt><dd>${esc(n.tradition)}${n.subtradition?" — "+esc(n.subtradition):""}</dd>
     <dt>Kind</dt><dd>${esc(n.kind)}</dd>
     <dt>Structure</dt><dd>${(n.nondual_types||[]).map(t=>{
        const s=STRUCT.find(x=>x[0]===t);return s?esc(s[1]):esc(t);}).join("<br>")}</dd>
     <dt>Dating</dt><dd>${esc(n.date_confidence)} confidence · ${esc(n.date_type)}</dd>
     ${(n.concepts||[]).length?`<dt>Concepts</dt><dd>${(n.concepts||[]).map(esc).join(" · ")}</dd>`:""}
   </dl>
   <div class="sect"><h3>What this contributes</h3><p>${esc(n.claim).replace(/\n+/g,"</p><p>")}</p></div>
   ${n.dating_note?`<div class="sect"><h3>How the date is established</h3><p>${esc(n.dating_note)}</p></div>`:""}
   ${n.controversies?`<div class="sect"><h3>Controversies</h3><p>${esc(n.controversies)}</p></div>`:""}
   ${(n.primary_sources||[]).length?`<div class="sect"><h3>Primary sources</h3><ul class="cites">${
      (n.primary_sources||[]).map(p=>`<li>${esc(p)}</li>`).join("")}</ul></div>`:""}
   <div class="sect"><h3>Sources (${(n.citations||[]).length})</h3><ul class="cites">${citeList(n.citations)}</ul></div>
   <div class="sect"><h3>Connections (${edges.length})</h3>
     ${edges.length?`<ul class="edgelist">${edges.map(([c,ar,other])=>`
        <li><div class="hd"><span class="tag ${c.type}">${c.type} · ${esc(c.confidence)}</span>
          <span>${ar}</span> <a class="goto" href="#" data-goto="${esc(other?other.id:"")}">${esc(other?other.label:c.to)}</a></div>
          ${c.label?`<div style="font-size:13.5px;margin-top:3px">${esc(c.label)}</div>`:""}
          ${c.type==="D"?`<div class="banner">COMPARATIVE PARALLEL — NO HISTORICAL TRANSMISSION DEMONSTRATED</div>`:""}
          ${c.type==="F"?`<div class="banner">TRADITIONAL LINEAGE CLAIM — not independently demonstrable</div>`:""}
          ${c.type==="E"?`<div class="banner">CONTESTED — scholarship is divided</div>`:""}
          <div style="font-size:13px;color:var(--ink-s);margin-top:4px">${esc(c.note)}</div>
          <ul class="cites" style="margin-top:5px">${citeList(c.citations)}</ul>
        </li>`).join("")}</ul>`:`<p style="color:var(--ink-m)">No connection on this map. Standing alone is
        information: nothing was drawn to it that could not be sourced.</p>`}
   </div>`;
  body.querySelectorAll("[data-goto]").forEach(a=>a.onclick=ev=>{ev.preventDefault();
    PANEL_OPENER=a;
    const t=BYID[a.dataset.goto];if(!t)return;
    if(t._s<S.t0||t._s>S.t1){S.t0=Math.min(S.t0,t._s-40);S.t1=Math.max(S.t1,t._e+40);}
    openPanel(a.dataset.goto);render();renderMinimap();});
  document.getElementById("panel").classList.add("open");
  render();
}

/* ---------- table view ---------- */
function renderTable(){
  const tb=document.querySelector("#tbl tbody");
  const rows=NODES.filter(n=>visible(n)&&matchQ(n)).slice(0,1200);
  tb.innerHTML=rows.map(n=>`<tr>
    <td style="white-space:nowrap">${esc(n.date_display)}</td>
    <td><span class="lk" data-id="${esc(n.id)}">${esc(n.label)}</span></td>
    <td>${esc(LANE_LABEL[laneOf(n)]||laneOf(n))}</td>
    <td>${esc(n.tradition)}</td>
    <td>${(n.nondual_types||[]).join(", ")}</td>
    <td>${esc(n.date_confidence)} · ${esc(n.date_type)}</td>
    <td>${(n.citations||[]).length} source${(n.citations||[]).length===1?"":"s"}</td></tr>`).join("");
  tb.onclick=e=>{const s=e.target.closest(".lk");if(s)openPanel(s.dataset.id);};
}

/* ---------- bibliography ---------- */
function buildBiblio(){
  const m=new Map();
  const add=c=>{if(!c||!c.ref)return;const k=c.ref.trim();
    if(!m.has(k)||(!m.get(k)&&c.url))m.set(k,c.url||m.get(k)||"");};
  NODES.forEach(n=>(n.citations||[]).forEach(add));
  CONNS.forEach(c=>(c.citations||[]).forEach(add));
  const arr=[...m.entries()].sort((a,b)=>a[0].localeCompare(b[0]));
  document.getElementById("bibcount").textContent=arr.length+" distinct sources.";
  document.getElementById("biblio").innerHTML=arr.map(([ref,url])=>
    `<li>${url?`<a href="${esc(url)}" target="_blank" rel="noopener">${esc(ref)}</a>`
      :`${esc(ref)} <span class="nolink">— no stable public URL</span>`}</li>`).join("");
}

/* ---------- every control, the legend and the labels, made to agree with S ---------- */
function segSync(id,val){
  const seg=document.getElementById(id); if(!seg) return;
  [...seg.children].forEach(b=>b.setAttribute("aria-pressed", String(b.dataset.v===val)));
}
function eraSync(){
  const box=document.getElementById("eraBtns"); if(!box) return;
  box.setAttribute("role","group");
  box.setAttribute("aria-label","Historical period");
  [...box.children].forEach(b=>{
    const on = Math.abs(+b.dataset.a-S.t0)<0.6 && Math.abs(+b.dataset.b-S.t1)<0.6;
    b.setAttribute("aria-pressed", String(on));
    b.classList.toggle("on", on);
  });
}
function laneCaption(){
  const el0=document.getElementById("laneCaption"); if(!el0) return;
  el0.innerHTML = S.lanes==="strand"
    ? '<b>Lanes are interpretive strands</b> — trajectories through the material '
      +'(teachers, institutions, translations, diasporas, scholarship), not places.'
    : '<b>Lanes are geographic regions</b> — the region an entry belongs to or is about. '
      +'Entries the record treats as transnational are marked '
      +'<span class="tn-key">transnational</span> and shown in their primary region; '
      +'switch <i>Transnational</i> to <i>Group together</i> to see them in one lane.';
}
function syncControls(){
  segSync("colorMode",S.colorMode);
  segSync("axisMode",S.axisMode);
  segSync("edgeMode",S.edgeMode);
  segSync("scopeMode",S.scope);
  segSync("laneMode",S.lanes);
  segSync("transnatMode",S.transnat);
  segSync("searchMode",S.searchMode);
  eraSync(); laneCaption();
  document.querySelectorAll("#connFilters .pill").forEach(p=>
    p.setAttribute("aria-pressed", String(S.types.has(p.dataset.t))));
  document.querySelectorAll("#confFilters .pill").forEach(p=>
    p.setAttribute("aria-pressed", String(S.confs.has(p.dataset.c))));
  const si=document.getElementById("search"); if(si && si.value!==S.q0) si.value=S.q0||"";
  const vt=document.getElementById("viewToggle");
  if(vt) vt.textContent = S.view==="table" ? "Timeline view" : "Table view";
  const lm=document.getElementById("laneMode");
  if(lm) lm.setAttribute("aria-label", S.lanes==="strand"
      ? "Lane mode: interpretive strands" : "Lane mode: geographic regions");
  const tw=document.getElementById("transnatWrap");
  if(tw) tw.hidden = (S.lanes!=="geo");
}
window.__syncControls=syncControls;

/* ---------- 6. Reset returns the atlas to exactly the state it loads in ----------
   The theme is deliberately NOT reset: it is a reading preference, not a view of the
   data, and a reader who chose Akaal did not ask for the lights to come back on. */
function resetAll(){
  Object.keys(S0).forEach(k=>{ S[k]=S0[k]; });
  S.q=""; S.q0=""; S.sel=null;
  S.types=new Set("ABCDEF"); S.confs=new Set(CONF_ORDER);
  setLanes(S.lanes);
  const si=document.getElementById("search"); if(si) si.value="";
  const tv=document.getElementById("tableView"); if(tv) tv.style.display="none";
  ["viz","minimap","hint"].forEach(id=>{const e=document.getElementById(id); if(e) e.hidden=false;});
  closePanel(true);
  if(typeof chip==="function") chip("",0);
  buildLegend(); syncControls(); render(); renderMinimap();
}
window.__resetAtlas=resetAll;

/* ---------- one action that opens a curated group instead of a wall of buttons ---------- */
let PENDING_SET=null;
function chip(label,n){
  const c=document.getElementById("setChip"); if(!c) return;
  if(!S.nodeSet){ c.hidden=true; c.innerHTML=""; return; }
  c.hidden=false;
  c.innerHTML='<span>Showing <b>'+n+'</b> entries \u2014 '+label+
    '</span><button type="button" id="setChipClear">Show the whole atlas \u2715</button>';
  const cb=document.getElementById("setChipClear");
  if(cb) cb.onclick=()=>{ S.nodeSet=null; chip("",0);
    S.t0=S0.t0; S.t1=S0.t1; syncControls(); render(); renderMinimap(); };
}
function showSet(ids,label){
  const have=ids.filter(i=>BYID[i]);
  if(!have.length) return;
  S.nodeSet=new Set(have); S.sel=null; S.q=""; S.q0="";
  const si=document.getElementById("search"); if(si) si.value="";
  let lo=Infinity, hi=-Infinity;
  have.forEach(i=>{const n=BYID[i]; lo=Math.min(lo,n._s); hi=Math.max(hi,n._e);});
  const pad=Math.max(30,(hi-lo)*0.08);
  S.t0=lo-pad; S.t1=hi+pad;
  const box=document.getElementById("atlasExplorer");
  if(box && !box.classList.contains("open") && typeof revealAtlas==="function") revealAtlas(false);
  chip(label||"a curated group",have.length);
  syncControls(); render(); renderMinimap();
  if(box) box.scrollIntoView({behavior:"smooth",block:"start"});
}
window.__atlasShowSet=showSet;
document.addEventListener("click",e=>{
  const a=e.target.closest("[data-nodes]");
  if(!a) return;
  e.preventDefault();
  const ids=(a.getAttribute("data-nodes")||"").split(",").filter(Boolean);
  const label=a.getAttribute("data-setlabel")||"a curated group";
  if(typeof DB==="undefined"||!DB){ PENDING_SET=[ids,label];
    if(typeof revealAtlas==="function") revealAtlas(false); return; }
  showSet(ids,label);
});

/* ---------- 9. the panel gives focus back to whatever opened it ---------- */
let PANEL_OPENER=null, PENDING_NODE=null;
function closePanel(silent){
  const p=document.getElementById("panel");
  if(p) p.classList.remove("open");
  S.sel=null;
  const back=PANEL_OPENER; PANEL_OPENER=null;
  if(!silent){ render(); }        /* the chart is rebuilt, so resolve focus after it */
  let target=back;
  /* openPanel re-renders the timeline, which replaces the very node that was clicked.
     Re-find it by id so focus lands on the live element, not a detached one. */
  if(back && !document.contains(back) && back.dataset && back.dataset.id){
    target=document.querySelector('#viz g.node[data-id="'+
      (window.CSS&&CSS.escape?CSS.escape(back.dataset.id):back.dataset.id)+'"]');
  }
  if(target && document.contains(target)){
    try{ target.focus({preventScroll:true}); }catch(e){ try{ target.focus(); }catch(e2){} }
  }
}
window.__closePanel=closePanel;

/* ---------- UI ---------- */
function seg(id,key,after){
  const box=document.getElementById(id); if(!box) return;
  box.onclick=e=>{const b=e.target.closest("button");if(!b)return;
    S[key]=b.dataset.v;(after||render)();syncControls();};
}
const ERA_BTNS={full:[["All",-1520,2030],["Ṛgvedic",-1520,-600],["Ancient",-900,200],["Classical",100,900],["Medieval",800,1450],
   ["Early modern",1400,1800],["Colonial",1750,1950],["1900–2026",1900,2030]],
 modern:[["All",1900,2030],["1900–45",1898,1946],["1945–70",1944,1971],["1970–90",1969,1991],
   ["1990–2010",1989,2011],["2010–26",2009,2030]]};
function bindUI(){
  document.getElementById("eraBtns").innerHTML=ERA_BTNS[MODE==="modern"?"modern":"full"]
    .map(e=>`<button data-a="${e[1]}" data-b="${e[2]}" aria-pressed="false">${e[0]}</button>`).join("");
  seg("colorMode","colorMode",()=>{buildLegend();render();});
  seg("axisMode","axisMode",()=>{render();renderMinimap();});
  seg("edgeMode","edgeMode",render);
  seg("scopeMode","scope",()=>{render();renderMinimap();});
  if(document.getElementById("laneMode"))
    seg("laneMode","lanes",()=>{setLanes(S.lanes);buildLegend();render();renderMinimap();});
  document.getElementById("eraBtns").onclick=e=>{const b=e.target.closest("button");if(!b)return;
    S.t0=+b.dataset.a;S.t1=+b.dataset.b;render();renderMinimap();syncControls();};
  document.getElementById("search").oninput=e=>{
    S.q0=e.target.value; S.q=e.target.value.trim().toLowerCase();
    render();renderMinimap();syncControls();};
  if(document.getElementById("searchMode"))
    seg("searchMode","searchMode",()=>{render();renderMinimap();});
  if(document.getElementById("transnatMode"))
    seg("transnatMode","transnat",()=>{buildLegend();render();renderMinimap();});
  document.getElementById("panelClose").onclick=()=>{closePanel(false);};
  document.getElementById("resetBtn").onclick=()=>{ resetAll(); };
  document.getElementById("themeToggle").onclick=e=>{
    const dark=document.documentElement.dataset.theme==="akaal";
    document.documentElement.dataset.theme=dark?"kaal":"akaal";
    e.target.textContent=dark?"Akaal":"Kaal";buildLegend();render();renderMinimap();};
  document.getElementById("viewToggle").onclick=e=>{
    S.view=S.view==="chart"?"table":"chart";
    document.getElementById("tableView").style.display=S.view==="table"?"block":"none";
    document.getElementById("viz").hidden=S.view==="table";
    document.getElementById("minimap").hidden=S.view==="table";
    document.getElementById("hint").hidden=S.view==="table";
    if(S.view==="table")renderTable();
    syncControls();};
  /* zoom + pan */
  const svg=document.getElementById("viz");
  svg.addEventListener("wheel",e=>{e.preventDefault();
    const r=svg.getBoundingClientRect();const yv=invX(e.clientX-r.left);
    const k=e.deltaY>0?1.16:1/1.16;
    let a=yv-(yv-S.t0)*k, b=yv+(S.t1-yv)*k;
    if(b-a<20){const c=(a+b)/2;a=c-10;b=c+10;}
    if(MODE==="modern"){a=Math.max(1895,a);b=Math.min(2032,b);}else if(b-a>3600){a=-1520;b=2040;}
    S.t0=Math.max(MODE==='modern'?1895:-1520,a);S.t1=Math.min(MODE==='modern'?2032:2040,b);render();renderMinimap();},{passive:false});
  let pan=null;
  svg.addEventListener("pointerdown",e=>{if(e.target.closest(".node"))return;
    pan={x:e.clientX,t0:S.t0,t1:S.t1};svg.classList.add("dragging");svg.setPointerCapture(e.pointerId);});
  svg.addEventListener("pointermove",e=>{if(!pan)return;
    const r=svg.getBoundingClientRect();
    const d=invX(pan.x-r.left)-invX(e.clientX-r.left);
    S.t0=pan.t0+d;S.t1=pan.t1+d;render();renderMinimap();});
  const endPan=()=>{pan=null;svg.classList.remove("dragging");};
  svg.addEventListener("pointerup",endPan);svg.addEventListener("pointercancel",endPan);
  addEventListener("resize",()=>{render();renderMinimap();});
  addEventListener("keydown",e=>{if(e.key==="Escape"){
    const p=document.getElementById("panel");
    if(p&&p.classList.contains("open")){e.preventDefault();closePanel(false);}}});
  bindMinimap();
}
boot();
